import React, { Component } from "react";
import { Row, Col,  Modal, Radio, Checkbox, DatePicker, notification, Input  } from "antd";
import { Form } from "@ant-design/compatible";
import "../memberSearch/searchMember.css";
//import { Row, Col, Modal, Radio, Checkbox } from "antd";
import PrimaryButton from "../CommonComponent/Buttons/PrimayButton";
import Config from "../../config";
import ReactToPrint from "react-to-print";
import moment from "moment";

class Attestation extends Component {
    state = {
        isLoading: true,
        hasData: false,
        csnpHasData: false,      // NEW: Flag for CSNP eligibility
        ssbciHasData: false,     // NEW: Flag for SSBCI eligibility
        activeModule: null,      // NEW: 'CSNP' or 'SSBCI' - determines which modal form to show
        showUpdateButton: false,
        isModalVisible: false,
        selectedOption: null,
        applicationDate: null,
        effectiveDate: null,
        attestationDate: null,
        ssbci_Id:"",
        ssbciConditions: [],          // (add if not already there)
        ssbciPhoneNumber: "",         // NEW
        phoneNumber: "",              // NEW (was missing — used by the Input)
        npi: "",                      // NEW (was missing — used by the Input)
        conditions: {
          cvd: false,
          diabetes: false,
          mental: false,
          chronicHeartFailure: false,
          cld: false,
        },
      };
    
    componentDidMount() {
        if (this.props.isButtonVisible) {
          this.checkAttestationEligibility();
        }
      }
    componentDidUpdate(prevProps) {
      if (!prevProps.isButtonVisible && this.props.isButtonVisible) {
        this.checkAttestationEligibility();
        }
      }
      
    checkAttestationEligibility = () => {
        // Reset flags and start loading
        this.setState({
            isLoading: true,
            csnpHasData: false,
            ssbciHasData: false,
            showUpdateButton: false,
            loader2: true, 
            isModalOpen: true
        });

        // Check both modules
        const csnpPromise = this.GetCSNPSubscribers();
        const ssbciPromise = this.GetSSBCISubscribers();

        // Use Promise.allSettled to track when both API calls finish
        Promise.allSettled([csnpPromise, ssbciPromise]).then(() => {
            // After both API calls are finished, update the overall loading/data state
            this.setState((prevState) => ({
                isLoading: false,
                hasData: prevState.csnpHasData || prevState.ssbciHasData,
                showUpdateButton: prevState.csnpHasData || prevState.ssbciHasData,
            }));
        });
    }

    // EXISTING API CALL: Fetches CSNP eligibility
    GetCSNPSubscribers = () => {
        const queryParams = new URLSearchParams({
          mbi: this.props.MBI,
          CustID: sessionStorage.getItem("planName") === "liberty" ? "101" : sessionStorage.getItem("Tanent"),
          username: sessionStorage.getItem("userName"),
          planName: sessionStorage.getItem("planName")
        }).toString();

        return fetch(`${Config.Enrolment}/GetCSNPSubscribers?${queryParams}`, {
          method: "GET",
          headers: {
            Authorization: this.props.authToken,
            Accept: "application/json",
            "Content-type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("CSNP data@", data);
            if (Array.isArray(data) && data.length > 0 && data[0].mbi) {
              this.setState({ csnpHasData: true });
            } else {
              this.setState({ csnpHasData: false });
            }
          })
          .catch((error) => {
            console.error("Error fetching CSNP data", error);
            this.setState({ csnpHasData: false });
          });
      };

    // NEW API CALL: Fetches SSBCI eligibility
    GetSSBCISubscribers = () => {
        const queryParams = new URLSearchParams({
          mbi: this.props.MBI,
       //   mbi: "1A13H76NF28",
          CustID: sessionStorage.getItem("planName") === "liberty" ? "101" : sessionStorage.getItem("Tanent"),
          username: sessionStorage.getItem("userName"),
          planName: sessionStorage.getItem("planName")
        }).toString();

        return fetch(`${Config.Enrolment}/GetSSBCISubscribers?${queryParams}`, { // New Endpoint
          method: "GET",
          headers: {
            Authorization: this.props.authToken,
            Accept: "application/json",
            "Content-type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("SSBCI data@", data);
            if (Array.isArray(data) && data.length > 0 && data[0].mbi) {
              this.setState({ 
                showUpdateButton: true,
                isLoading: false,
                 ssbciHasData: true,
                  // If SSBCI data includes condition details, you would update ssbciConditions here:
                  // ssbciConditions: data[0].conditions || this.state.ssbciConditions 
              });
               // ✅ Call your external function here
               this.getAllSSBCI();
            } else {
              this.setState({ 
                showUpdateButton: false,
                isLoading: false,
                ssbciHasData: false 
              });
              this.getAllSSBCI();
            }
          })
          .catch((error) => {
            console.error("Error fetching data", error);
            this.setState({
              isLoading: false,
              ssbciHasData: false,
              showUpdateButton: false,
            });
          });
      };
      getAllSSBCI = async (
        value,
        value1,
        value2,
        value3,
        value4,
        value5,
        value6
      ) => {
        try {
          console.log("inside*** ssbci")
          this.setState({ SearchLoading: true, isPageSearch: false });
          var mappingDataString = sessionStorage.getItem("taxidNpiMapping");
          let formattedData = [];
    
          if (sessionStorage.getItem("ProviderRole") === "PROVIDER") {
            console.log("inside provider");
            const npi = JSON.parse(sessionStorage.getItem("npivalue"))[0];
            const taxids = JSON.parse(sessionStorage.getItem("taxid")) || [];
    
            formattedData = taxids.map((taxid) => ({
              TaxID: taxid,
              NPI: npi || null,
            }));
          }
          // Check role
          const roleName = sessionStorage.getItem("rolename") || "";
    
          if (roleName.includes("Group User") || roleName.includes("IPA User")) {
            console.log("inside Gourp");
            // Choose the correct mapping based on role
            const mappingKey = roleName.includes("IPA User")
              ? "latestTaxidNpiMapping"
              : "taxidNpiMapping";
    
            const taxidNpiMapping =
              JSON.parse(sessionStorage.getItem(mappingKey)) || [];
    
            // Transform it into desired structure
            formattedData = taxidNpiMapping.flatMap((item) =>
              (item.NPI || []).map((npi) => ({
                TaxID: item.TaxID || null,
                NPI: npi,
              }))
            );
          }

          // Remove duplicate TaxID + NPI combinations
          formattedData = Array.from(
            new Map(
              formattedData.map((item) => [
                `${item.TaxID}|${item.NPI}`,
                item
              ])
            ).values()
          );
    
          // You can now send `formattedData` in your payload
          console.log("Formatted Data:", formattedData);
          
          console.log("mappingData", mappingDataString);
          var npiArray = [];
          if (mappingDataString) {
            try {
              var mappingData = JSON.parse(mappingDataString); // <-- Parse JSON string to array
              mappingData.forEach((item) => {
                if (Array.isArray(item.NPI)) {
                  item.NPI.forEach((npi) => npiArray.push(npi));
                }
              });
              console.log("npiArray:", npiArray);
            } catch (e) {
              console.error("Failed to parse mappingData", e);
            }
          } else {
            npiArray = JSON.parse(sessionStorage.getItem("npivalue"));
            console.log(npiArray);
          }
          console.log("mapping@@#", mappingDataString);
          console.log("!!!!!", sessionStorage.getItem("taxid"));
          let response = await fetch(`${Config.Enrolment}/GetAllSSBCI`, {
            method: "POST",
            headers: {
              Authorization: this.props.authToken, // <-- Using the token from getAuthToken
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              pageSize: 10,
              pageNumber: 1,
              providerDetails: formattedData,
            
              // providerNPI: ["1003042581"],
              subsciberId: this.state.filterSubId || null, // <- set search box value,
              mbi: this.props.MBI,
           //   mbi: "1A13H76NF28",
              memberName: this.state.filterMemberName || null,
              attestationType: this.state.filterattestationType || null,
              applicationDate: this.state.applicationDate || null,
              attestationDate: this.state.attestationdateOnChange || null,
              attestedBy: this.state.filterAttestatedBy || null,
              status: this.state.filterStatusCode || null,
              effectiveDate: this.state.effectiveDate || null,
              planname: sessionStorage.getItem("planName"),
              custId:
                sessionStorage.getItem("planName") === "liberty"
                  ? "101"
                  : parseInt(sessionStorage.getItem("Tanent")),
              userName: sessionStorage.getItem("userName"),
            }),
          });
    
          const data = await response.json();
          // Extract all selected SSBCI conditions
let selectedConditions = [];

// Loop through each record returned in the list
   console.log("data",data)
   const firstItem = data?.list?.[0] || {};

   // Resolve phone number: use API value if present, else default
   const rawPhone = firstItem?.phoneNumber;
   const resolvedPhone =
     rawPhone && String(rawPhone).trim() !== ""
     ? String(rawPhone).replace(/\D/g, "").slice(0, 10)
     : "9999999999";
   this.setState({
     ssbci_Id:data.list[0].ssbci_Id,
     applicationDate: data.list[0].applicationDate,
     effectiveDate: data.list[0].effectiveDate,
     ssbciPhoneNumber: resolvedPhone,   // stash for handleUpdate
   })
data.list.forEach(item => {
  if (item.patientCondition) {
    try {
      const parsed = JSON.parse(item.patientCondition);

      // Filter only selected = 1
      const filtered = parsed.filter(cond => cond.selected === 1);

      selectedConditions = [...selectedConditions, ...filtered];

    } catch (err) {
      console.error("Error parsing patientCondition:", err);
    }
  }
});

// Remove duplicates based on Lookup_Code
const uniqueConditions = Array.from(
  new Map(selectedConditions.map(item => [item.Lookup_Code, item])).values()
);

// Save to state
this.setState({ ssbciConditions: uniqueConditions });

console.log("Selected SSBCI Conditions:", uniqueConditions);

        } catch (error) {
          console.error("Failed to fetch CSNP data:", error);
        }
      };
      
      // MODIFIED: Takes the module type to open the correct modal
      handleUpdate = (module) => {
        console.log("update data@@",this.state.ssbciConditions)      
        //  Use `module` arg — the old check read this.state.activeModule BEFORE setState,
        // so it was always stale.
        const isUltimateSSBCI =
          sessionStorage.getItem("planName") === "ultimate" &&
          this.state.activeModule === "SSBCI";

        this.setState({ 
            isModalVisible: true, 
            activeModule: module,
            // Reset selectedOption when opening a new modal type
            selectedOption: null, 
            attestationDate: null,
             // Pre-fill phone for SSBCI (defaults to "9999999999"), blank for CSNP
            phoneNumber:
            module === "SSBCI"
              ? this.state.ssbciPhoneNumber || "9999999999"
              : "",
      
          // Pre-fill first provider NPI for Ultimate SSBCI
            npi: isUltimateSSBCI
            ? this.getFirstProviderNpi()
            : "",
        });
      };
      
      handleOptionChange = (e) => {
        const selectedOption = e.target.value;
      
        this.setState({
          selectedOption,
          // CSNP logic
          conditions: selectedOption === "hasConditions"
            ? this.state.conditions // Keep current values
            : {
                cvd: false,
                diabetes: false,
                mental: false,
                chronicHeartFailure: false,
                cld: false,
              }, // Reset all checkboxes if other radio selected
        });
        console.log("sss",this.state.cvd)
        console.log("rrr",this.state.diabetes)
        console.log("ppp",this.state.mental)
      };

      
      handleCheckboxChange = (e) => {
        console.log("handleCheckboxChange",e.target.name)
        const { name, checked } = e.target;
        this.setState(prevState => ({
          conditions: {
            ...prevState.conditions,
            [name]: checked
          }
        }));
      };
      
      // handleModalCancel = () => {
      //   this.setState({ isModalVisible: false, activeModule: null });
      // };
      handleModalCancel = () => {
        this.setState({
          isModalVisible: false, 
          activeModule: null,
          phoneNumber: "",
          npi: "",
        });
      };

      // Ensure this function is updated to handle SSBCI payload if necessary
      handleModalSave = () => {
        const {
          selectedOption,
          conditions,
          attestationDate,
          activeModule // Use this to determine which payload to build
        } = this.state;
        this.setState({ isLoading: true})
      
        const planName = sessionStorage.getItem("planName");
        
        // Example logic for CSNP only (You need to duplicate/modify this for SSBCI)
         // First Name and Last Name logic
    const username = sessionStorage.getItem("userName") || "";
    const nameParts = username.trim().split(/\s+/);
    const Firstname = nameParts.slice(0, -1).join(" ");
    const Lastname = nameParts.length > 1 ? nameParts[nameParts.length - 1] : "";
        // Common fields
    const commonFields = {
       //   contractID: "H2962",   // uhp only has one pbp H2962
          PlanName: planName,
          username: sessionStorage.getItem("userName"),
          custId: sessionStorage.getItem("planName") === "liberty" ? "101" : parseInt(sessionStorage.getItem("Tanent")),
          mbi: this.props.MBI,
       //   mbi: "1A13H76NF28",
          PbpCode: this.props.memberDetails.PbpCode,
          attestationDate: attestationDate?.format("YYYY-MM-DD"),
    };
  
    let payload = {};
  
    // ✅ CASE 1: CSNP payload
    if (activeModule === "CSNP") {
      payload = {
        ...commonFields,
          myPatient: selectedOption === "hasConditions" ? 1 : 0,
          patientCondition: {
            cardiovascular: 0,
            diabetes: 0,
            mentalHealth: 0,
            myPatientConditionDoNotConfirm: 0,
            notMyPatient: 0,
          },
        };
      
        // Update patient conditions if applicable
        if (selectedOption === "hasConditions") {
          payload.patientCondition.cardiovascular = conditions?.cvd ? 1 : 0;
          payload.patientCondition.diabetes = conditions?.diabetes ? 1 : 0;
          payload.patientCondition.mentalHealth = conditions?.mental ? 1 : 0;
          payload.patientCondition.chronicHeartFailure = conditions?.chronicHeartFailure ? 1 : 0;
          payload.patientCondition.chronicLungDisorder = conditions?.cld ? 1 : 0;
        } else if (selectedOption === "noConditions") {
          payload.patientCondition.myPatientConditionDoNotConfirm = 1;
        } else if (selectedOption === "notMyPatient") {
          payload.patientCondition.notMyPatient = 1;
        }
       }
  
    // ✅ CASE 2: SSBCI payload
    else if (activeModule === "SSBCI") {
      payload = {
        ...commonFields,
       // "contractID": "H2962",
        phoneNumber: this.state.phoneNumber, // Added
        npi: this.state.npi,                 // Added
        Firstname: Firstname,
        Lastname: Lastname,
        myPatient: 0, // default
        // applicationDate: this.state.applicationDate || "",
        // effectiveDate: this.state.effectiveDate || "",
        applicationDate: this.state.applicationDate
        ? this.state.applicationDate.substring(0, 10)
        : "",
    
      effectiveDate: this.state.effectiveDate
        ? this.state.effectiveDate.substring(0, 10)
        : "",
        ssbci_Id:this.state.ssbci_Id,
        patientCondition: {
          myPatientConditionDoNotConfirm: 0,
          notMyPatient: 0,
        },
      };
  
      // Logic based on selectedOption
      if (selectedOption === "SSBCI_confirm") {
        payload.myPatient = 1;
      } else if (selectedOption === "SSBCI_noConfirm") {
        payload.patientCondition.myPatientConditionDoNotConfirm = 1;
      } else if (selectedOption === "notMyPatient") {
        payload.patientCondition.notMyPatient = 1;
      }
        }
      
        console.log("Final Payload:", payload);
      
        // ✅ Select endpoint dynamically
    const endpoint =
      activeModule === "SSBCI"
        ? `${Config.Enrolment}/CreateSSBCISubscribers`
        : `${Config.Enrolment}/CreateCSNPSubscribers`;
  
    // ✅ Call API
    fetch(endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: this.props.authToken,
          },
          body: JSON.stringify(payload),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("API response:", data);
            if (data.actionStatus === 200) {
              // alert("Saved Successfully!");
              notification.open({
                description: "Attestation Updated Successfully",
                type: "success", // this sets the success color
              });
              this.GetCSNPSubscribers();
              this.GetSSBCISubscribers();
            } else {
             // alert("Error: " + data.message);
          this.GetCSNPSubscribers();
          this.GetSSBCISubscribers();
             notification.open({
              message: "Error",
              description: data.message || "Something went wrong",
              type: "error",
            });
             console.log("error")
            }
          })
          .catch((error) => {
            console.error("API Error:", error);
           // alert("Something went wrong. Please try again.");
            notification.open({
            message: "Error",
            description: "Something went wrong. Please try again.",
            type: "error",
          });
        });

        this.setState({ isModalVisible: false });
        // NOTE: In a real app, you would call the corresponding API here.
      }; 
      getFirstProviderNpi = () => {
        try {
          // Provider
          if (sessionStorage.getItem("ProviderRole") === "PROVIDER") {
            const npiArray = JSON.parse(
              sessionStorage.getItem("npivalue") || "[]"
            );
      
            return npiArray?.[0] || "";
          }
      
          // Group User / IPA User
          const roleName = sessionStorage.getItem("rolename") || "";
      
          if (
            roleName.includes("Group User") ||
            roleName.includes("IPA User")
          ) {
            const mappingKey = roleName.includes("IPA User")
              ? "latestTaxidNpiMapping"
              : "taxidNpiMapping";
      
            const mappingData = JSON.parse(
              sessionStorage.getItem(mappingKey) || "[]"
            );
      
            // Example:
            // [
            //   { TaxID: "593140335", NPI: ["1124475884", "1861470916"] }
            // ]
      
            for (const item of mappingData) {
              if (Array.isArray(item.NPI) && item.NPI.length > 0) {
                return item.NPI[0];
              }
            }
          }
      
          return "";
        } catch (error) {
          console.error("Error getting first provider NPI:", error);
          return "";
        }
      };
      clearSSBCIContactFields = () => {
        this.setState({
          phoneNumber: "",
          npi: "",
        });
      };
      
  render() {
    const PbpCode = this.props.memberDetails.PbpCode;
    const planName = sessionStorage.getItem("planName");
    const cvdSupportedPlans = {
      ultimate: [
        "021",
        "026",
        "029",
        "033",
        "050",
        "051",
        "052"
      ],
      liberty: ["004"],
      csh: [
        "005",
        "006",
        "002",
        "003"
      ]
    };
    
    const showChronicConditions =
    planName === "solis" ||
    cvdSupportedPlans[planName]?.includes(PbpCode);

    const isSolisMentalPbp =
    planName === "solis" &&
    ["027", "034"].includes(String(PbpCode));

    console.log("showChronicConditions",cvdSupportedPlans[planName])
    console.log("state",PbpCode)
    console.log("true/false: ",cvdSupportedPlans[planName]?.includes(PbpCode))

    const cldSupportedPlans = {
      ultimate: [
        "023",
        "025",
      ],
    };
    const showCldConditions = cldSupportedPlans[planName]?.includes(PbpCode);
    // console.log("showCldConditions",cldSupportedPlans[planName])
    // console.log("state cld: ",PbpCode)
    // console.log("true/false: ",cldSupportedPlans[planName]?.includes(PbpCode))

    // Determine if the Update button should be disabled based on the active module
    const isUltimateSSBCI =
  sessionStorage.getItem("planName") === "ultimate" &&
  this.state.activeModule === "SSBCI";

const isUltimateSSBCIContactMissing =
  isUltimateSSBCI &&
  (
    !/^\d{10}$/.test(this.state.phoneNumber?.trim() || "") ||
    !/^\d{10}$/.test(this.state.npi?.trim() || "")
  );
    const isSaveDisabled = 
        !this.state.selectedOption || 
        !this.state.attestationDate ||
        isUltimateSSBCIContactMissing ||
        (this.state.activeModule === "CSNP" && this.state.selectedOption === "hasConditions" &&
            !(this.state.conditions.cvd || this.state.conditions.diabetes || this.state.conditions.mental || this.state.conditions.chronicHeartFailure || this.state.conditions.cld ));

    return (
        <div className="p-2 pb-3">
      <Row 
      className="pl-2 member-info-header"
      style={{ marginTop: '15px' }} // adjust as needed
      >
          <Col span={12}>Attestation Type</Col>
          <Col span={12}>Action</Col>
      </Row>
        <hr></hr>
        {/* NEW CONDITIONAL RENDERING FOR CSNP & SSBCI STATUS */}
        {this.state.isLoading ? (
  <div style={{ textAlign: 'center', padding: '40px 0', fontSize: '16px', color: '#888' }}>
    Loading attestation info...
  </div>
) : (this.state.csnpHasData || this.state.ssbciHasData) ? (
  <>
  {/* CSNP Row */}
  {this.state.csnpHasData && (
  <Row  
  className="p-2 row-details mb-2"
  style={{ marginTop: '30px' }} // adjust as needed
  >
    <Col span={12}>
      <strong>CSNP</strong>
    </Col>
    <Col span={12}>
        <button
          className="details-tab p-1 pl-2 pr-2"
          style={{ padding: '4px 12px', fontSize: '14px' }}
          onClick={() => this.handleUpdate('CSNP')} // Pass 'CSNP' to handler
        >
          Update
        </button>
    </Col>
    </Row>
      )}
                    
                    {/* SSBCI Row */}
                    {this.state.ssbciHasData && (
                        <Row  
                        className="p-2 row-details mb-2"
                        style={{ marginTop: this.state.csnpHasData ? '10px' : '30px' }} // Adjust spacing
                        >
                            <Col span={12}>
                                <strong>SSBCI</strong>
                            </Col>
                            <Col span={12}>
                                <button
                                    className="details-tab p-1 pl-2 pr-2"
                                    style={{ padding: '4px 12px', fontSize: '14px' }}
                                    onClick={() => this.handleUpdate('SSBCI')} // Pass 'SSBCI' to handler
                                >
                                    Update
                                </button>
                            </Col>
                        </Row>
                    )}
                </>
) : (
  <div style={{ textAlign: 'center', padding: '40px 0', fontSize: '16px', color: '#888' }}>
    No Attestation Found !!
  </div>
)}

  <Modal
  title="Attestation Form"
  open={this.state.isModalVisible}
  onCancel={this.handleModalCancel}
  maskClosable={false}  // This prevents closing when clicking outside the modal
  footer={[
    <button
      key="cancel"
      onClick={this.handleModalCancel}
      style={{
        padding: "6px 16px",
        border: "1px solid #ccc",
        borderRadius: 4,
        backgroundColor: "#fff",
        marginRight: 16, // Add spacing to the right
      }}
    >
      Cancel
    </button>,
    <button
      key="save"
      onClick={this.handleModalSave}
      disabled={isSaveDisabled}
      style={{
        padding: "6px 16px",
        border: "none",
        borderRadius: 4,
        backgroundColor: isSaveDisabled ? "#a0c4ff" : "#1677ff",
        color: "#fff",
      }}
    >
      Update
    </button>,
  ]}
  
  bodyStyle={{ padding: 24 }}
  width={600}
>
  <Form layout="vertical">
    <Form.Item>
 {/* CONDITIONAL MODAL CONTENT */}
    {this.state.activeModule === "CSNP" ? (
      // --- CSNP MODAL CONTENT (Your existing logic) ---
      <Radio.Group
        onChange={this.handleOptionChange}
        value={this.state.selectedOption}
        style={{ display: "flex", flexDirection: "column", gap: 12 }}
      >
        <Radio value="hasConditions">
          <div>
            <div>This is my patient and has the conditions of:</div>
          </div>
        </Radio>
        {/* INFO MESSAGE */}
        {this.state.selectedOption === "hasConditions" && !(
           this.state.conditions.cvd ||
           this.state.conditions.diabetes ||
           this.state.conditions.mental ||
           this.state.conditions.chronicHeartFailure ||
           this.state.conditions.cld
          ) && (
           <div style={{ color: "#faad14", fontSize: 13, paddingLeft: 28 }}>
              Please select at least one condition.
           </div>
        )}
        <div style={{ paddingLeft: 28, display: "flex", flexDirection: "column", gap: 10 }}>
        {
                    showChronicConditions && !isSolisMentalPbp && (
                    <>
              <Checkbox
                name="cvd"
                style={{ marginLeft: "8px" }} 
                disabled={this.state.selectedOption !== "hasConditions"}
                checked={this.state.conditions.cvd}
                onChange={this.handleCheckboxChange}
              >
                {" "}{planName === "solis" ? "Cardiovascular Diseases (CVDs)/Chronic Heart Failure (CHF)" : "Cardiovascular Diseases (CVDs)"}
              </Checkbox>
              <Checkbox
                name="diabetes"
                disabled={this.state.selectedOption !== "hasConditions"}
                checked={this.state.conditions.diabetes}
                onChange={this.handleCheckboxChange}
              >
                Diabetes Mellitus
              </Checkbox>
              {planName !== "solis" && ( 
                    <Checkbox
                      name="chronicHeartFailure"
                      disabled={this.state.selectedOption !== "hasConditions"}
                      checked={this.state.conditions.chronicHeartFailure}
                      onChange={this.handleCheckboxChange}
                    >
                      Chronic Heart Failure
                    </Checkbox>
                    )}
                </>
                    )
                    }
              {isSolisMentalPbp && (
              <Checkbox
                name="mental"
                disabled={this.state.selectedOption !== "hasConditions"}
                checked={this.state.conditions.mental}
                onChange={this.handleCheckboxChange}
              >
                Mental Health Condition (that is, bipolar disorders, major depressive disorders, paranoid disorder, schizophrenia, and/or schizoaffective disorder)
              </Checkbox>
              )}
              {/* Chronic Lung Disorder/COPD is only for up now */}
              {showCldConditions &&
                    <Checkbox
                      name="cld"
                      disabled={
                        this.state.isReadOnly ||
                        this.state.selectedOption !== "hasConditions"
                      }
                      checked={this.state.conditions.cld}
                      onChange={this.handleCheckboxChange}
                    >
                      Chronic Lung Disorder/COPD
                    </Checkbox>
              }
                    {/* Only for CSH --> Diabetes, Chronic Heart Failure (CHF), or Cardiovascular Disorder (CVD)  */}
                    {sessionStorage.getItem("planName") === "csh" && (
                    <Checkbox
                      name="mental"
                      disabled={
                        this.state.isReadOnly ||
                        this.state.selectedOption !== "hasConditions"
                      }
                      checked={this.state.conditions.mental}
                      onChange={this.handleCheckboxChange}
                    >
                      Diabetes, Chronic Heart Failure (CHF), or Cardiovascular Disorder (CVD) 
                    </Checkbox>
                    )}
            </div>

        <Radio value="noConditions">
          This is my patient, but I do not confirm the presence of either condition above.
        </Radio>

        <Radio value="notMyPatient">
          This is not my patient.
        </Radio>
      </Radio.Group>
) : this.state.activeModule === "SSBCI" ? (
      <div
          style={{
              display: "flex",
              flexDirection: "column",
              gap: 12,
            }}
      >
{/* Option 1: Confirm */}
        <Checkbox
             checked={this.state.selectedOption === "SSBCI_confirm"}
             disabled={this.state.isReadOnly}
             onChange={() => this.handleOptionChange({ target: { value: "SSBCI_confirm" } })}
        >
            {
                      planName === "ultimate"
                       ?  <>
                        I confirm that my records indicate this patient meets all of the following criteria:
                       <br />
                       (1) Has one or more of the below comorbid and medically complex chronic conditions
                       that are life-threatening or significantly limit the patient’s overall health or function,
                       <br />
                       (2) Is at high risk of hospitalization or other adverse health outcomes,
                       <br />
                       (3) Requires intensive care coordination.
                     </>
                       : "I confirm my records for this patient include a diagnosis of one or more of the above qualifying conditions and the patient is at high risk of hospitalization or other adverse health outcomes."
            }
        </Checkbox>
            
              {/* READ-ONLY Conditions List */}
                  {this.state.ssbciConditions && (
                    <ul
                        style={{
                            listStyleType: 'disc',
                            paddingLeft: 40,
                            marginTop: -4,
                            marginBottom: 4,
                            color: '#525252' 
                          }}
                    >
                                  {/* Mapping the dynamic data to the read-only list */}
                                  {this.state.ssbciConditions
                                      .filter(item => item.selected === 1)
                                      .map((item) => (
                                      <li key={item.LookUp_Code}>
                                          {item.LookUp_Desc}
                                      </li>
                                  ))}
                                </ul>
                              )}
            
                              {/* Option 2: No Confirm */}
                              <Checkbox
                                checked={this.state.selectedOption === "SSBCI_noConfirm"}
                                disabled={this.state.isReadOnly}
                                onChange={() => this.handleOptionChange({ target: { value: "SSBCI_noConfirm" } })}
                                style={{ whiteSpace: 'normal' }}
                              >
                                No, my records for this patient do not include a diagnosis of one or more of the above qualifying conditions, is at high risk of hospitalization or other adverse health outcomes.
                              </Checkbox>
            
                              {/* Option 3: Not My Patient */}
                              <Checkbox
                                checked={this.state.selectedOption === "notMyPatient"}
                                disabled={this.state.isReadOnly}
                                onChange={() => this.handleOptionChange({ target: { value: "notMyPatient" } })}
                              >
                                My records indicate this is **not** my patient.
                              </Checkbox>
                            </div>
            
                          ) : null}
                        {/* END CONDITIONAL MODAL CONTENT */}
                        {sessionStorage.getItem("planName") === "ultimate" &&
  this.state.activeModule === "SSBCI" && (
    <div
      style={{
        display: "flex",
        gap: "16px",
        marginTop: "16px",
      }}
    >
      {/* Phone Number */}
      <div style={{ flex: 1 }}>
        <label>
          Phone Number{" "}
          <span style={{ color: "red" }}>*</span>
        </label>

        <Input
          placeholder="Enter 10 digit Phone Number"
          value={this.state.phoneNumber}
          maxLength={10}
          onChange={(e) => {
            // Allow numbers only
            const value = e.target.value.replace(/\D/g, "");
            this.setState({
              phoneNumber: value,
            });
          }}
          disabled={this.state.isReadOnly}
          style={{ marginTop: 4 }}
        />

        {/* Phone Number Warning */}
        {this.state.phoneNumber &&
          !/^\d{10}$/.test(this.state.phoneNumber.trim()) && (
            <div
              style={{
                color: "red",
                fontSize: "12px",
                marginTop: "4px",
              }}
            >
              Phone Number must be exactly 10 digits.
            </div>
          )}
      </div>

      {/* NPI */}
      <div style={{ flex: 1 }}>
        <label>
          NPI{" "}
          <span style={{ color: "red" }}>*</span>
        </label>

        <Input
          placeholder="Enter 10 digit NPI"
          value={this.state.npi}
          maxLength={10}
          onChange={(e) => {
            // Allow numbers only
            const value = e.target.value.replace(/\D/g, "");
            this.setState({
              npi: value,
            });
          }}
          disabled={this.state.isReadOnly}
          style={{ marginTop: 4 }}
        />

        {/* NPI Warning */}
        {this.state.npi &&
          !/^\d{10}$/.test(this.state.npi.trim()) && (
            <div
              style={{
                color: "red",
                fontSize: "12px",
                marginTop: "4px",
              }}
            >
              NPI must be exactly 10 digits.
            </div>
          )}
      </div>
    </div>
  )}
    </Form.Item>

    <Form.Item
       label={
          <span>
             Attestation Date (represents your signature)
             <span style={{ color: 'red' }}> *</span>
          </span>
        }
    >
      <DatePicker
    format="MM-DD-YYYY"
    style={{ width: "100%" }}
    value={this.state.attestationDate}
    onChange={(date) => this.setState({ attestationDate: date })}
    placeholder="mm-dd-yyyy"
  />
    </Form.Item>
  </Form>
</Modal>
 </div>
    );
  }
}

export default Attestation;
